import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { PromptTypes } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PromptTypeOption } from 'src/app/pages/prompt-register/models/prompt-type-option.interface';
import { addSpacesToTypeName } from '../../../../pipes/split-enum-strings/add-spaces.pipe';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { promptTypeOptionSelectors } from '../state/prompt-type-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: PromptTypeSelectComponent,
        },
    ],
    selector: 'ndt-prompt-type-select',
    templateUrl: './prompt-type-select.component.html',
    standalone: false
})
export class PromptTypeSelectComponent extends LcsSingleSelectBase<PromptTypeOption> implements OnInit {
   @Input() excludedPromptTypes: PromptTypes[] = [];

   @Input() includedPromptTypes: PromptTypes[] | null;

   promptTypes$: Observable<PromptTypeOption[]>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.promptTypes$ = this.store.pipe(
         select(promptTypeOptionSelectors.selectFilteredItems),
         map((items: Array<PromptTypeOption>) => {
            let filteredItems = items;

            if (!this.includedPromptTypes && this.excludedPromptTypes && this.excludedPromptTypes.length > 0) {
               filteredItems = filteredItems.filter((item) => {
                  return !this.excludedPromptTypes?.includes(item.typeName as PromptTypes);
               });
            }

            if (!this.excludedPromptTypes && this.includedPromptTypes && this.includedPromptTypes.length > 0) {
               filteredItems = filteredItems.filter((item) => {
                  return this.includedPromptTypes?.includes(item.typeName as PromptTypes);
               });
            }
            return filteredItems;
         })
      );
   }

   displayWith(item: PromptTypeOption | null): string | null {
      return item ? (item.typeName ? addSpacesToTypeName(item.typeName) : null) : null;
   }

   trackBy(item: PromptTypeOption | null) {
      return item ? item.typeName : null;
   }
}
